const WarningIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" {...props}>
      <path fill="currentColor" d="M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z" />
    </svg>
  );
};

export default WarningIcon;
